import type { CmsRichTextVerySimple } from '@cms/types/cmsRichTextVerySimple'
import type { OffersAndCompetitionsMediaPicker } from '@common/model_builder/mediaPickers/offersAndCompetitionsMediaPicker'

export class OffersAndCompetitionsConfigurationPropsApi {
    // Group = Global Configuration
    /**
     * The logo displayed in the top-right corner of cards for or any offers or competitions with “Loyalty Offer” or “LoyaltyCompetition” toggled on.
     */
    loyaltyOfferOrCompetitionLogo?: OffersAndCompetitionsMediaPicker

    /**
     * Message displaying in the top-right corner of cards when an offer or competition is expiring within the configured threshold period.
     *
     * Supports ${daysToExpiry} as a variable.
     */
    expiryMessage: CmsRichTextVerySimple

    /**
     * Message displaying in the top-right corner of cards when an offer or competition is expiring on the next day.
     */
    expiryMessageTomorrow: CmsRichTextVerySimple

    /**
     * Message displaying in the top-right corner of cards when an offer or competition is expiring on the current day.
     */
    expiryMessageToday: CmsRichTextVerySimple

    /**
     * Message displaying in the top-right corner of cards when an offer or competition has expired.
     */
    expiredMessage: CmsRichTextVerySimple

    /**
     * The number of days before the expiry of an offer or competition before the relevant expiry message should be displayed.
     */
    expiryMessageThreshold: number

    modalButtonLabel?: string
}
